export default __webpack_public_path__ + "static/treatmentareas_bikiniafter-d8235c56ce4c78761dcb158e75123485.webp";